import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import { DATE_FORMAT_ISO, DATE_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const PersonalInfoSection = ({ data, errors, onChange, onClearErrors }) => {
  return (
    <>
      <h6 className="text-primary mb-3">
        <i className="fa fa-user me-2"></i>Personal Information
      </h6>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>
            First Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={data.firstName}
            isInvalid={!!errors.firstName}
            onChange={(e) => {
              onChange({ firstName: e.target.value });
              onClearErrors();
            }}
            placeholder="Enter first name"
          />
          <Form.Control.Feedback type="invalid">{errors.firstName || 'First name is required'}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Last Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={data.lastName}
            isInvalid={!!errors.lastName}
            onChange={(e) => {
              onChange({ lastName: e.target.value });
              onClearErrors();
            }}
            placeholder="Enter last name"
          />
          <Form.Control.Feedback type="invalid">{errors.lastName || 'Last name is required'}</Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>
            Date of Birth <span className="text-danger">*</span>
          </Form.Label>
          <Datetime
            timeFormat={false}
            dateFormat={DATE_FORMAT_WEB}
            closeOnSelect
            utc={true}
            inputProps={{
              placeholder: DATE_FORMAT_WEB,
              className: errors.dateOfBirth ? 'form-control is-invalid' : 'form-control',
            }}
            value={DateTimeFormater(data.dateOfBirth, null, DATE_FORMAT_WEB)}
            onChange={(e) => {
              if (moment.isMoment(e) && e.isValid()) {
                onChange({ dateOfBirth: e.format(DATE_FORMAT_ISO) });
                onClearErrors();
              }
            }}
          />
          {errors.dateOfBirth && (
            <div className="invalid-feedback d-block">{errors.dateOfBirth || 'Date of birth is required'}</div>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Phone <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="tel"
            value={data.phone}
            isInvalid={!!errors.phone}
            onChange={(e) => {
              onChange({ phone: e.target.value });
              onClearErrors();
            }}
            placeholder="Enter phone number"
          />
          <Form.Control.Feedback type="invalid">{errors.phone || 'Phone number is required'}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Gender <span className="text-danger">*</span>
          </Form.Label>
          <div>
            <Form.Check
              inline
              label="Male"
              name="gender"
              type="radio"
              id="male"
              value="Male"
              checked={data.gender === 'Male'}
              onChange={(e) => {
                onChange({ gender: e.target.value });
                onClearErrors();
              }}
            />
            <Form.Check
              inline
              label="Female"
              name="gender"
              type="radio"
              id="female"
              value="Female"
              checked={data.gender === 'Female'}
              onChange={(e) => {
                onChange({ gender: e.target.value });
                onClearErrors();
              }}
            />
            <Form.Check
              inline
              label="Other"
              name="gender"
              type="radio"
              id="other"
              value="Unknow"
              checked={data.gender === 'Unknow'}
              onChange={(e) => {
                onChange({ gender: e.target.value });
                onClearErrors();
              }}
            />
          </div>
          {errors.gender && <div className="invalid-feedback d-block">{errors.gender || 'Gender is required'}</div>}
        </Form.Group>
      </Row>
    </>
  );
};

PersonalInfoSection.propTypes = {
  data: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClearErrors: PropTypes.func.isRequired,
};

export default PersonalInfoSection;
